/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocArrowInIcon20Solid = forwardRef('DocArrowInIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.004 2H7a3 3 0 0 0-3 3v8.586c.29.183.632.289 1 .289h.792a2.375 2.375 0 0 1 3.754-2.678l2.614 2.24A3.377 3.377 0 0 1 12.684 18H13a3 3 0 0 0 3-3V7.998h-3.746a2.25 2.25 0 0 1-2.25-2.25V2Z" }),
        React.createElement("path", { d: "m15.863 6.498-4.359-4.359v3.609c0 .414.336.75.75.75h3.61Z" }),
        React.createElement("path", { d: "M1 10a1 1 0 0 1 1 1v1a3 3 0 0 0 3 3h3.797l-1.448-1.24a1 1 0 0 1 1.302-1.52l2.614 2.242a2 2 0 0 1 0 3.037l-2.614 2.24a1 1 0 0 1-1.302-1.518L8.797 17H5a5 5 0 0 1-5-5v-1a1 1 0 0 1 1-1Z" })));
});
